export default "__VITE_ASSET__wpfe85_LDX7mQwNH65Va0A__"